import {
  CloudSyncOutlined, GatewayOutlined,
  OrderedListOutlined, PauseCircleOutlined,
  SaveOutlined
} from '@ant-design/icons';
import { FloatButton, Popover, Tooltip } from 'antd';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import NumberingContent from './Content/NumberingContent';
import "./../Editor.scss"
import ScanDirectionContent from './Content/ScanDirectionContent';
import AccessibleIcon from '@mui/icons-material/Accessible';
import RouteIcon from '@mui/icons-material/Route';
import ViewModuleRoundedIcon from '@mui/icons-material/ViewModuleRounded';
import BlockContent from './Content/BlockContent';

const EslToolbar = (props) => {
  const [open, setOpen] = useState(false);
  const collapsed = useSelector((state) => state.sidebar.isCollapsed);

  return (
    <FloatButton.Group
      icon={<CloudSyncOutlined/>}
      open={open}
      shape="square"
      trigger="click"
      placement="bottom"
      className="esl-toolbar"
      style={{
        marginTop: "7.5px",
        marginLeft: collapsed ? "35px" : "175px",
        transition: "margin-left 0.25s ease"
      }}
      onClick={() => setOpen(!open)}
    >
      <Tooltip placement="right" title="Speichern (Ctrl + S)">
        <FloatButton icon={<SaveOutlined/>} onClick={() => props.save()}/>
      </Tooltip>
      <Tooltip placement="right" title="Spezieller Stuhl">
        <FloatButton icon={<AccessibleIcon/>} onClick={() => props.markAsSpecial()}/>
      </Tooltip>
      <Popover
        content={<NumberingContent
          numbering={props.numbering}
          clearNumbering={props.clearNumbering}
          setNumbering={props.setNumbering}
          setHorizontalNumberingDirection={props.setHorizontalNumberingDirection}
          horizontalNumberingDirection={props.horizontalNumberingDirection}
          setVerticalNumberingDirection={props.setVerticalNumberingDirection}
          verticalNumberingDirection={props.verticalNumberingDirection}
          numberSeatsPerRow={props.numberSeatsPerRow}
          numberSeatsPerBlock={props.numberSeatsPerBlock}
          number={props.number}
          setNumber={props.setNumber}
        />}
        trigger="hover"
        placement="right"
        overlayStyle={{
          minWidth: 200,
          height: 150
      }}>
        <FloatButton icon={<OrderedListOutlined/>}  />
      </Popover>
      <Popover
        content={
        <BlockContent
          block={props.block}
          setBlocks={props.setBlocks}
        />}
        title="Block"
        trigger="hover"
        placement="right"
        overlayStyle={{
          minWidth: 200,
          height: 150
        }}>
        <FloatButton icon={<ViewModuleRoundedIcon/>}  />
      </Popover>
      {!props.isManualSelecting && <Popover
        content={<ScanDirectionContent
          clearScanDirection={props.clearScanDirection}
          handleScanDirectionChange={props.handleScanDirectionChange}
          scanDirection={props.scanDirection}
          setScanDirection={props.setScanDirection}
          horizontalDirection={props.horizontalDirection}
          setHorizontalDirection={props.setHorizontalDirection}
        />
      }
        trigger="hover"
        placement="right"
        title="Modus"
        overlayStyle={{
          minWidth: 300,
          height: 150
        }}>
        <FloatButton icon={<RouteIcon/>}  />
      </Popover>
      }
      {props.isManualSelecting &&
        <FloatButton
          icon={<PauseCircleOutlined style={{color: "red" }} onClick={() => props.setIsManualSelecting(false)}/>}
        />
      }
    </FloatButton.Group>
  )
}

export default EslToolbar
